import shape5_6 from './shape-5-6.svg';
import shape6_7 from './shape-6-7.svg';
import shape8plus from './shape-8-plus.svg';
import shapeLowerThan_5 from './shape-lower-than-5.svg';
import shapeNoScore from './shape-no-score.svg';

export { shape5_6, shape6_7, shape8plus, shapeLowerThan_5, shapeNoScore };
